import type { DialogService, ConfirmOptions, AlertOptions } from '@exiftrator/shared';

export function createDialogService(): DialogService {
  return {
    async confirm(message: string, _options?: ConfirmOptions): Promise<boolean> {
      return window.confirm(message);
    },

    async alert(message: string, _options?: AlertOptions): Promise<void> {
      window.alert(message);
    },

    async prompt(message: string, defaultValue?: string): Promise<string | null> {
      return window.prompt(message, defaultValue);
    },

    async showError(title: string, message: string): Promise<void> {
      window.alert(`${title}\n\n${message}`);
    },
  };
}
